<template>
  <main>
   <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <section-article id="scrollToOnLoad"
      v-if="mainArticle.id" :article="mainArticle"></section-article>
    <section-figures :figures="allArticles" btnText="Resources" itemColSize="4"></section-figures>
   <section-support></section-support>
  </main>
</template>

<script>
import article from '@/api/v1/article';
import categories from '@/api/v1/categories';
import Hero from '@/components/Hero';
import Article from '@/components/Article';
import Figures from '@/components/Figures';
import Support from '@/components/Support/Index';

export default {
  components: {
    'section-hero': Hero,
    'section-article': Article,
    'section-figures': Figures,
    'section-support': Support,
  },
  data() {
    return {
      bgImg: 'Banner3-What-I-need-to-know-',
      subtitle: this.$t('nav.whatINeedToKnow'),
      mainArticle: {},
      allArticles: [],
    };
  },
  methods: {
    getArticle() {
      const succ = (response) => {
        this.mainArticle = response.data.article;
      };
      article.index(succ, this.$route.params.articleId);
    },
    getCategories() {
      const succ = (response) => {
        this.allArticles = response.data.categories[0].articles;
      };
      categories.index(succ);
    },
  },
  created() {
    this.getArticle();
    this.getCategories();
  },
  watch: {
    $route() {
      this.getArticle();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/helpers/_variables.scss';

.section {
  &--agora-project {
    padding: 100px 0;
  }
  &--opinions {
    padding: 175px 0 118px;
    background-color: $color--orange;
  }
  &--news {
    padding: 100px 0;
    text-align: center;
  }
}

.opinion {
  text-align: center;
  padding: 0 40px;
  &__content {
    font-size: 20px;
    font-style: italic;
    font-family: Montserrat;
    color: $color--white;
    position: relative;
    text-align: center;
    margin-bottom: 15px;
    &:before {
      content: url('../assets/ico-quotation-mark.png');
      position: absolute;
      top: -40px;
      transform: translateX(-50%);
      left: 50%;
    }
  }
  &__signature {
    font-family: Montserrat;
    font-size: 20px;
    font-weight: 600;
  }
}

.news {
  &__content{
    padding: 25px 5px;;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/NeedToKnow.vue